"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The AuthenticateUpdateResponse model module.
 * @module model/AuthenticateUpdateResponse
 * @version 0.2.0
 */
var AuthenticateUpdateResponse = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>AuthenticateUpdateResponse</code>.
   * @alias module:model/AuthenticateUpdateResponse
   */
  function AuthenticateUpdateResponse() {
    _classCallCheck(this, AuthenticateUpdateResponse);

    AuthenticateUpdateResponse.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(AuthenticateUpdateResponse, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>AuthenticateUpdateResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AuthenticateUpdateResponse} obj Optional instance to populate.
     * @return {module:model/AuthenticateUpdateResponse} The populated <code>AuthenticateUpdateResponse</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new AuthenticateUpdateResponse();

        if (data.hasOwnProperty('token')) {
          obj['token'] = _ApiClient["default"].convertToType(data['token'], 'String');
        }

        if (data.hasOwnProperty('redirect_org_id')) {
          obj['redirect_org_id'] = _ApiClient["default"].convertToType(data['redirect_org_id'], 'String');
        }
      }

      return obj;
    }
  }]);

  return AuthenticateUpdateResponse;
}();
/**
 * @member {String} token
 */


AuthenticateUpdateResponse.prototype['token'] = undefined;
/**
 * @member {String} redirect_org_id
 */

AuthenticateUpdateResponse.prototype['redirect_org_id'] = undefined;
var _default = AuthenticateUpdateResponse;
exports["default"] = _default;